import axios from "axios";
import routes from "../../configs/api";

const updatePassword = (data) => {
  return new Promise((resolve, reject) => {
    const URL = routes.UPDATE_PASSWORD;
    axios
      .post(URL, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default updatePassword;
